module.exports = __webpack_public_path__ + "static/media/topIconImage.729845a8.svg";